export default "__VITE_ASSET__DT0fs1P2__";